export default class Banner {
  constructor(title, subtitle, link, image, isPublished = false) {
    this.title = title;
    this.subtitle = subtitle;
    this.link = link;
    this.image = image;
    this.is_published = isPublished;
  }
}
